import firebaseApp from "./config";

export const logout = async () => {
  const response = await firebaseApp.auth().signOut().then(() => {
      return {status: "ok", error: null }
  }, function(error) {
    return { status: "error", error: "Sign Out failed try again" }
  });
return response
}
